import React from "react";
import TimelineItem from "./TimelineItem";

import { useResources } from "@aetonix/hooks";

export default function ManagedNew(props) {
	const {
		localize,
	} = useResources();

	var notification = props.notification;
	var message = localize("banner.managedusernew", notification.from);
	var screen = props.screen;

	return (
		<TimelineItem content={message} iconName="info"  clearable notification={notification} screen={screen} />
	);
}
